export default "__VITE_ASSET__ae2cab61__"